import {defineComponent} from 'vue';
import {Vue, Options} from 'vue-property-decorator';

const ProductDetailsSectionMixin = defineComponent({
  props: {
    containerClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    hideContainer(doHide: boolean) {
      if (!this.containerClass) return;
      const container = document.querySelector(`.${this.containerClass}`);
      if (!container) return;

      const className = this.containerClass.split('--')[0] + '--hidden';
      if (doHide) {
        container.classList.add(className);
      } else {
        container.classList.remove(className);
      }
    }
  }
});

@Options({})
class ProductDetailsSectionClass extends Vue {
  containerClass: string;
  hideContainer: (doHide: boolean) => void;
}

export {
  ProductDetailsSectionMixin,
  ProductDetailsSectionClass
}
